import React, { useEffect, useState } from 'react'
import ExpenseCard from '../components/Expenses/main'

const ExpensesPage = () => {
  const [fadeIn, setFadeIn] = useState(false);

  useEffect(() => {
    setFadeIn(true);
  }, []);
  return (
    <div className={`flex   h-full  transition-opacity duration-700 ${fadeIn ? 'opacity-100' : 'opacity-0'}`}>
      <ExpenseCard/>
    </div>
  )
}

export default ExpensesPage